<script>
    import { api_host, user_store, user_info_store, page_setting_store, company_details_store } from "../../stores.js";
    import { init_data, get_user_info } from '../../init.js';
    import { state_codes } from '../../globals.js';
    import { push, querystring } from 'svelte-spa-router'
    import { onMount } from 'svelte';
    import Header from "../header.svelte";
    import { pop } from 'svelte-spa-router';
    import IFTAInput from "../../utils/iftainput.svelte";
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { getFormatDateByOffset, formatDate, handle_not_subscribed, deepCopy } from '../../utils/format.js';
    import { getTax, description_validation_func, rate_validation_func, quantity_validation_func, convert_tax_rates } from '../../utils/tax.js';
    import { toast_message } from '../../utils/toast_message.js';
    import Swal from "sweetalert2";
    import Itemselector from "../../utils/itemselector.svelte";


    let content_title = "Create Quote";
    let uid = "";
    let is_busy = true;
    let tomorrow = getFormatDateByOffset(1);
    let myself = {};
    let photos = [], fileinput;
    let tax_rate_options = [];
    let tax_rates = [];
    let extra_service_price_list = [];
	
	const onFileSelected = (e) => {
        const files = Array.from(e.target.files);
        files.forEach(file => {
            console.log('file', file);

            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = e => {
                let image = new Image();
                image.src = e.target.result;
                image.onload = () => {

                    let canvas = document.createElement('canvas');
                    let context = canvas.getContext('2d');

                    // Set the canvas dimensions to the desired downscaled size
                    let downscaledWidth = 400; // Adjust to your desired width
                    let downscaledHeight = (image.height / image.width) * downscaledWidth;
                    canvas.width = downscaledWidth;
                    canvas.height = downscaledHeight;

                    // Draw the image onto the canvas with the downscaled size
                    context.drawImage(image, 0, 0, downscaledWidth, downscaledHeight);

                    // Convert the downscaled image on the canvas to a base64 data URL with reduced quality
                    let downscaledDataURL = canvas.toDataURL('image/jpeg', 0.8); // Adjust quality as needed

                    photos = [
                        ...photos, 
                        {
                            filename: file.name,
                            body: downscaledDataURL
                        }
                    ];
                    console.log('downgraded', photos);
                }
            };
        });
    };

    const onFileRemoved = async (index) => {
        const result = await Swal.fire({
            title: "Are you sure you want to delete this photo?",
            text: '',
            buttonsStyling: true,
            confirmButtonClass: "button",
            confirmButtonText: 'Ok',
            cancelButtonText: "Cancel",
            showCancelButton: true,
            icon: "warning"
        });
        if (!result.isConfirmed) return;
        
        photos.splice(index);
        photos = photos;
    };

    user_store.subscribe(value => {
        myself = value;
    });

    company_details_store.subscribe(value => {
        if (!value.tax_rates) return;
        tax_rate_options = value.tax_rates;
        tax_rates = convert_tax_rates([], tax_rate_options);
        console.log('tax_rates', tax_rates);
        is_busy = false;
    });

    onMount(async () => {
        fields[0].value = "";
        fields[1].value = "";
        fields[2].value = "";
        fields[3].value = "";
        fields[4].value = "";
        fields[5].value = "";
        fields[6].value = "";
        fields[7].value = "";
        fields[8].value = "";
        fields[11].value = 1;
        const params = new URLSearchParams($querystring)
        if (params.has("uid")) {
            uid = params.get("uid");
            const { auth_type, auth_token, domain_code } = getToken();
            get_user_info(uid);
        }
    });

    const set_total_service_price = () => {
        fields[12].value = parseFloat(fields[10].value || 0) * parseFloat(fields[11].value || 0);

        let extra_service_price = 0;
        let extra_service_tax = 0;
        extra_service_price_list.forEach(item => {
            extra_service_price += item.rate * item.quantity;
            extra_service_tax += getTax(item.rate * item.quantity, item.tax_rates);
        });
        fields[23].value = fields[12].value + extra_service_price;
        
        let subtotal = fields[23].value;
        let service_tax = getTax(fields[12].value, tax_rates) + extra_service_tax;
        
        fields[24].value = service_tax.toFixed(2);
        fields[25].value = (subtotal + service_tax).toFixed(2);
    };

    let fields = [
        {
            "index": 0,
            "group": "contact1",
            "type": "text",
            "label": "Address",
            "value": "",
            "placeholder": "eg. 123 My Street",
            "name": "quote[address]",
            "validation_function": () => {
                if (fields[0].value.length) {
                    fields[0]['show_error'] = false;
                    return true;
                } else {
                    fields[0]['show_error'] = true;
                    fields[0]['error_text'] = 'Address is required';
                    return false;
                }
            }
        }, {
            "index": 1,
            "group": "contact1",
            "type": "text",
            "label": "City",
            "value": "",
            "placeholder": "eg. Phoenix",
            "name": "quote[city]",
            "validation_function": () => {
                if (fields[1].value.length) {
                    fields[1]['show_error'] = false;
                    return true;
                } else {
                    fields[1]['show_error'] = true;
                    fields[1]['error_text'] = 'City is required';
                    return false;
                }
            }
        }, {
            "index": 2,
            "group": "contact1",
            "type": "select",
            "label": "State",
            "value": "Arizona",
            "select_options": Object.keys(state_codes),
            "name": "quote[state]",
            "validation_function": () => {
                if (fields[2].value.length) {
                    fields[2]['show_error'] = false;
                    return true;
                } else {
                    fields[2]['show_error'] = true;
                    fields[2]['error_text'] = 'Invalid State';
                    return false;
                }
            }
        }, {
            "index": 3,
            "group": "contact1",
            "type": "text",
            "label": "Zip Code",
            "value": "",
            "placeholder": "Optional (eg. 85001)",
            "name": "quote[zipcode]",
            "validation_function": () => {
                const zipformat = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
                if (fields[3].value.length == 0) return true;
                if (fields[3].value.match(zipformat)) {
                    fields[3]['show_error'] = false;
                    return true;
                } else {
                    fields[3]['show_error'] = true;
                    fields[3]['error_text'] = 'Invalid zipcode';
                    return false;
                }
            }
        }, {
            "index": 4,
            "group": "contact2",
            "type": "text",
            "label": "First Name",
            "value": "",
            "placeholder": "eg. Alfred",
            "name": "quote[first_name]",
            "validation_function": () => {
                if (fields[4].value.length) {
                    fields[4]['show_error'] = false;
                    return true;
                } else {
                    fields[4]['show_error'] = true;
                    fields[4]['error_text'] = 'First Name is required';
                    return false;
                }
            }
        }, {
            "index": 5,
            "group": "contact2",
            "type": "text",
            "label": "Last Name",
            "value": "",
            "placeholder": "eg. Smith",
            "name": "quote[last_name]",
            "validation_function": () => {
                if (fields[5].value.length) {
                    fields[5]['show_error'] = false;
                    return true;
                } else {
                    fields[5]['show_error'] = true;
                    fields[5]['error_text'] = 'Last Name is required';
                    return false;
                }
            }
        }, {
            "index": 6,
            "group": "contact2",
            "type": "text",
            "label": "Email",
            "value": "",
            "placeholder": "eg. asmith@google.com",
            "name": "quote[email]",
            "validation_function": () => {
                const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                if (fields[6].value.match(mailformat)) {
                    fields[6]['show_error'] = false;
                    return true;
                } else {
                    fields[6]['show_error'] = true;
                    fields[6]['error_text'] = 'Invalid email';
                    return false;
                }
            }
        }, {
            "index": 7,
            "group": "contact3",
            "type": "text",
            "label": "Home Phone",
            "value": "",
            "placeholder": "eg. 000-000-0000",
            "name": "quote[home_phone]",
            'change_function': (evt) => {
                var x = evt.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                evt.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            "validation_function": () => {
                const phoneformat = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                if (fields[7].value.match(phoneformat)) {
                    fields[7]['show_error'] = false;
                    return true;
                } else {
                    fields[7]['show_error'] = true;
                    fields[7]['error_text'] = 'Invalid phone number';
                    return false;
                }
            }
        }, {
            "index": 8,
            "group": "contact3",
            "type": "text",
            "label": "Mobile Phone",
            "value": "",
            "placeholder": "eg. 000-000-0000",
            "name": "quote[mobile_phone]",
            'change_function': (evt) => {
                var x = evt.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                evt.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            "validation_function": () => {
                const phoneformat = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                if (fields[8].value.match(phoneformat)) {
                    fields[8]['show_error'] = false;
                    return true;
                } else {
                    fields[8]['show_error'] = true;
                    fields[8]['error_text'] = 'Invalid phone number';
                    return false;
                }
            }
        }, {
            "index": 9,
            "group": "pricing1-temp",
            "type": "select",
            "label": "Payment Method",
            "value": "Credit Card",
            "select_options": ['Credit Card', 'Cash', 'Check'],
            "name": "quote[payment_method]",
            "validation_function": () => { return true; }
        }, {
            "index": 10,
            "group": "pricing1",
            "type": "text",
            "label": "Rate $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[service_rate]",
            "change_function": (evt) => {
                fields[10].value = parseFloat(evt.target.value).toFixed(2);
                set_total_service_price();
                if (fields[10].value > 0) {
                    fields[10]['show_error'] = false;
                } else {
                    fields[10]['show_error'] = false;
                    fields[10]['error_text'] = 'Service Rate is required';
                }
            },
            "validation_function": () => {
                if (parseFloat(fields[10].value) >= 0) {
                    fields[10]['show_error'] = false;
                    return true;
                } else {
                    fields[10]['show_error'] = true;
                    fields[10]['error_text'] = 'Service Rate is required';
                    return false;
                }
            }
        }, {
            "index": 11,
            "group": "pricing1",
            "type": "text",
            "label": "Quantity",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[service_quantity]",
            "change_function": (evt) => {
                fields[11].value = parseFloat(evt.target.value).toFixed(2);
                set_total_service_price();
                if (fields[11].value > 0) {
                    fields[11]['show_error'] = false;
                } else {
                    fields[11]['show_error'] = false;
                    fields[11]['error_text'] = 'Service Rate is required';
                }
            },
            "validation_function": () => {
                if (parseFloat(fields[11].value) > 0) {
                    fields[11]['show_error'] = false;
                    return true;
                } else {
                    fields[11]['show_error'] = true;
                    fields[11]['error_text'] = 'Service Quantity is required';
                    return false;
                }
            }
        }, {
            "index": 12,
            "group": "pricing1",
            "type": "text",
            "label": "Service Price $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[service_price]",
            "validation_function": () => { return true; }
        }, {
            "index": 13,
            "group": "pricing0",
            "type": "select",
            "label": "Service Type",
            "style": "min-width: 200px;",
            "value": "Yard/Lawn Service",
            "change_function": (e) => {
                const new_val = e.target.value;
                if(new_val !== "Yard/Lawn Service") {
                    fields[17].hidden = true;
                    fields[18].hidden = true;
                }else{
                    fields[17].hidden = false;
                    fields[18].hidden = false;
                }
            },
            "select_options": [],
            "name": "quote[service_type]",
            "validation_function": () => { return true; }
        }, {
            "index": 14,
            "group": "service1",
            "type": "date",
            "label": "Service Date",
            "value": tomorrow,
            "name": "quote[day_of_service]",
            "validation_function": () => {
                return true;
            },
            'hidden': true,
        }, {
            "index": 15,
            "group": "service1",
            "type": "select",
            "label": "Time Preference",
            "value": "No Preference",
            "select_options": ['No Preference', 'Morning', 'Afternoon', '6AM', '7AM', '8AM', '9AM', '10AM', '11AM', '12PM', '1PM', '2PM', '3PM', '4PM', '5PM', '6PM'],
            "name": "quote[time_preference]",
            "hidden": true,
            "validation_function": () => { return true; }
        }, {
            "index": 16,
            "group": "service1",
            "type": "select",
            "label": "Service Frequency",
            "value": "Weekly",
            "select_options": [],
            "name": "quote[service_frequency]",
            "change_function": (evt) => {
                if (evt.target.value) {
                    fields[16]['show_error'] = false;
                } else {
                    fields[16]['show_error'] = true;
                    fields[16]['error_text'] = 'Service Frequency is required';
                }
                if (evt.target.value === 'One-Time') {
                    fields[22].hidden = true;
                } else {
                    fields[22].hidden = false;
                }
            },
            "validation_function": () => { return true; }
        }, {
            "index": 17,
            "group": "service1",
            "type": "select",
            "label": "Lawn",
            "value": "None",
            "select_options": [],
            "name": "quote[lawn]",
            "validation_function": () => { return true; }
        }, {
            "index": 18,
            "group": "service1",
            "type": "select",
            "label": "Last Cleanup?",
            "value": "Less than 2 weeks ago",
            "select_options": ['Less than 2 weeks ago', '2 to 4 weeks ago', '1 to 2 months ago', '3 months or more'],
            "name": "quote[last_cleanup]",
            "validation_function": () => { return true; }
        }, {
            "index": 19,
            "group": "service1",
            "type": "select",
            "label": "Back Yard Entry Instructions",
            "hidden": true,
            "value": "Other",
            "select_options": ['Already Open', 'Ring Door Bell', 'Not Required', 'Other'],
            "name": "quote[back_yard_entry]",
            "validation_function": () => { return true; }
        }, {
            "index": 20,
            "group": "comments",
            "type": "textarea",
            "label": "Tasks",
            "value": "",
            "placeholder": "... any tasks for this job.",
            "name": "quote[comments]",
            "maxlength": 5000,
            "validation_function": () => { return true; }
        }, {
            "index": 21,
            "group": "comments",
            "type": "textarea",
            "label": "Internal Comments",
            "value": "",
            "placeholder": "... any internal comments for this job.",
            "name": "quote[comments]",
            "maxlength": 5000,
            "validation_function": () => { return true; }
        }, {
            "index": 22,
            "group": "pricing1",
            "type": "text",
            "label": "Next Service Price $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[next_service_price]",
            "hidden": false,
            "validation_function": () => {
                if (fields[16].value === 'One-Time') {
                    fields[22]['show_error'] = false;
                    return true;
                }
                if (parseFloat(fields[22].value) > 0) {
                    fields[22]['show_error'] = false;
                    return true;
                } else {
                    fields[22]['show_error'] = true;
                    fields[22]['error_text'] = 'Next Service Price is required';
                    return false;
                }
            }
        }, {
            "index": 23,
            "group": "pricing2",
            "type": "text",
            "label": "Subtotal Price $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[subtotal_price]",
            "hidden": false,
            "validation_function": () => true
        }, {
            "index": 24,
            "group": "pricing2",
            "type": "text",
            "label": "Tax $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[tax_price]",
            "hidden": false,
            "validation_function": () => true
        }, {
            "index": 25,
            "group": "pricing2",
            "type": "text",
            "label": "Total Service Price $",
            "value": 0,
            "placeholder": "eg. 0.00",
            "name": "quote[total_service_price]",
            "hidden": false,
            "validation_function": () => true
        },
    ];

    const validateForm = () => {
        let is_valid = true;
        fields.forEach(field => {
            if (!field.validation_function()) {
                console.log('validate error:', field.index);
                is_valid = false;
            }
        });

        extra_service_price_list.forEach(item => {
            if (!description_validation_func(item)) {
                console.log('validate error:', item);
                is_valid = false;
            }
            if (!rate_validation_func(item)) {
                console.log('validate error:', item);
                is_valid = false;
            }
            if (!quantity_validation_func(item)) {
                console.log('validate error:', item);
                is_valid = false;
            }
        });
        extra_service_price_list = extra_service_price_list;

        return is_valid;
    };

    page_setting_store.subscribe(page_setting => {
        if(page_setting.lawn_options == undefined) return;
        let config_lawn_settings = Object.keys(page_setting.lawn_options);
        let config_service_settings = Object.keys(page_setting.service_frequency_options);
        let config_service_type_settings = Object.keys(page_setting.service_type_options).filter(key => page_setting.service_type_options[key]);
        console.log('config lawn settings', config_lawn_settings);
        console.log('config service settings', config_service_settings);
        console.log('config service type settings', config_service_type_settings);
        config_service_settings.unshift('');
        const freequencies = ["Every 3 weeks", "Every 6 weeks", "Every 2 months"];
        freequencies.forEach(f => config_service_settings.push(f));

        fields[16].select_options = config_service_settings;
        fields[17].value = config_lawn_settings.length > 0 ? config_lawn_settings[0] : '';
        fields[17].select_options = config_lawn_settings;
        fields[13].select_options = config_service_type_settings;
    });

    const upload_images = async (photos, tag) => {
        const urls = [];
        for (let i = 0; i < photos.length; i++) {
            const photo = photos[i];
            const payload = {
                tag,
                image: photo.body,
                filename: photo.filename
            };
            const { auth_type, auth_token, domain_code } = getToken();
            const res = await doFetch(
                `${api_host}/api/upload/image`,
                'POST',
                payload,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.url) urls.push(res.url);
        }
        return urls;
    };

    const createQuote = async (is_emailing) => {
        if (!myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        }

        if (validateForm()) {
            is_busy = true;

            const uploadedUrls = await upload_images(photos, 'quote');

            const get_state_code = (state) => {
                return state_codes[state];
            }
            const service_prices = deepCopy(extra_service_price_list);
            service_prices.push({
                "description": "",
                "rate": fields[10].value,
                "quantity": fields[11].value,
                "tax_rates": tax_rates,
                "is_main": true
            });
            
            const payload = {
                "uid": uid,
                "address": fields[0].value,
                "city": fields[1].value,
                "state": get_state_code(fields[2].value),
                "zipcode": fields[3].value,
                "service_date": formatDate(fields[14].value),
                "time_preference": fields[15].value,
                "lawn": fields[17].value,
                "service_frequency": fields[16].value,
                "service_type": fields[13].value,
                "last_service": fields[18].value,
                "back_yard_entry": fields[19].value,
                "first_name": fields[4].value,
                "last_name": fields[5].value,
                "full_name": `${fields[4].value} ${fields[5].value}`,
                "email": fields[6].value.toLowerCase(),
                "mobile_phone": fields[8].value,
                "home_phone": fields[7].value,
                "total_service_price": fields[25].value,
                "next_service_price": fields[22].value,
                "giftcard": '',
                "additional_comments": fields[20].value,
                "internal_comments": fields[21].value,
                "original_price": fields[11].value,
                "paymethod": fields[9].value,
                "is_emailing": is_emailing,
                "photos": uploadedUrls,
                service_prices
            };
            const { auth_type, auth_token, domain_code } = getToken();
            const res = await doFetch(
                `${api_host}/api/quote/create`,
                'POST',
                payload,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                init_data('quotes');
                toast_message(true, res.msg, 2000);
                push(`#/Quotes`);
            } else {
                toast_message(false, res.msg || 'Bad request', 2000);
            }
            is_busy = false;
        } else {
            toast_message(false, "Missing or invalid info", 3000);
        }
    };

    user_info_store.subscribe(value => {
        if (value.profile) {
            const profile = value.profile;
            fields[0].value = profile.address;
            fields[1].value = profile.city;
            fields[2].value = profile.state.length == 2 ? Object.keys(state_codes).find(item => state_codes[item] == profile.state) : profile.state;
            fields[3].value = profile.zipcode;
            fields[4].value = profile.first_name;
            fields[5].value = profile.last_name;
            fields[6].value = profile.email;
            fields[7].value = profile.home_phone;
            fields[8].value = profile.mobile_phone;
        }
    });
</script>

<Header bind:title={content_title} bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="section contactinfo">
        <div class="sectiontitle"><i class="fas fa-user"></i> Contact Information</div>
        <div class="sectioninfo">
            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "contact1") as nf}
                <IFTAInput
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>

            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "contact2") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>

            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "contact3") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
        </div>
    </div>

    <div class="section pricinginfo">
        <div class="sectiontitle"><i class="fas fa-dollar-sign"></i> Pricing Information</div>
        <div class="sectioninfo">
            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "pricing0") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    style={nf.style}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                    bind:hidden={nf.hidden}
                />
                {/each}
                {#each fields.filter((e)=>e.group === "pricing1") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                    bind:hidden={nf.hidden}
                />
                {/each}
                <div class="mockgroupitem">
                    <Itemselector 
                        title="Tax Rates"
                        bind:items={tax_rates}
                        collapsible={true}
                        changed={set_total_service_price}
                    />
                </div>
            </div>
            <div class="ff">
                <button on:click={()=>{ 
                    extra_service_price_list.push({ description: "", rate: 0, quantity: 1, price: 0, tax_rates: convert_tax_rates([], tax_rate_options)});
                    extra_service_price_list = extra_service_price_list;
                }} style="background-color: #1769aa; color: white;" disabled={is_busy}>
                    <i class="fa-plus" style="font-style: normal;"></i> 
                    Extra Service
                </button>
                {#each extra_service_price_list as item, index}
                <div class="formrow">
                    <IFTAInput 
                        type={"textarea"}
                        label={"Description"}
                        placeholder={""}
                        maxlength={5000}
                        bind:value={item.description}
                        show_error={item.description_show_error}
                        error_text={item.description_error_text}
                        validation_function={() => description_validation_func(item)}
                    />
                    <IFTAInput 
                        type={"text"}
                        label={"Rate $"}
                        bind:value={item.rate}
                        show_error={item.rate_show_error}
                        error_text={item.rate_error_text}
                        change_function={(evt) => {
                            item.rate = evt.target.value;
                            item.price = item.rate * item.quantity;
                            set_total_service_price();
                        }}
                        validation_function={() => rate_validation_func(item)}
                    />
                    <IFTAInput 
                        type={"text"}
                        label={"Quantity"}
                        bind:value={item.quantity}
                        show_error={item.quantity_show_error}
                        error_text={item.quantity_error_text}
                        change_function={(evt) => {
                            item.quantity = evt.target.value;
                            item.price = item.rate * item.quantity;
                            set_total_service_price();
                        }}
                        validation_function={() => quantity_validation_func(item)}
                    />
                    <div class="mockgroupitem">
                        <Itemselector 
                            title="Tax Rates"
                            bind:items={item.tax_rates}
                            collapsible={true}
                            changed={set_total_service_price}
                        />
                    </div>
                    <IFTAInput 
                        type={"text"}
                        label={"Price $"}
                        bind:value={item.price}
                    />
                    <button on:click={()=>{ 
                        extra_service_price_list.splice(index, 1); 
                        extra_service_price_list = extra_service_price_list;
                        set_total_service_price();
                    }} class="btn-icon"><i class="fas fa-trash"></i></button>
                </div>
                {/each}
                
            </div>
            <div class="ff formrow" style="width: 50%;margin-left: 50%;">
                {#each fields.filter((e)=>e.group === "pricing2") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                    bind:hidden={nf.hidden}
                />
                {/each}
            </div>
        </div>
    </div>

    <div class="section serviceinfo">
        <div class="sectiontitle"><i class="fas fa-info-circle"></i> Service Information</div>
        <div class="sectioninfo">

            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "service1") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:hidden={nf.hidden}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
            <div class="ff formrow">
                {#each fields.filter((e)=>e.group === "comments") as nf}
                <IFTAInput
                    type={(nf.type !== undefined) ? nf.type : ""}
                    label={(nf.label !== undefined) ? nf.label : ""}
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""}
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""}
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    maxlength={nf.maxlength}
                    bind:value={nf.value}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
        </div>
    </div>

    <div class="section photoinfo">
        <div class="sectiontitle"><i class="fas fa-info-circle"></i> Photos</div>
        <div class="sectioninfo">
            <div class="photo-list">
                {#each photos as photo, index}
                <div class="photo-item">
                    <img class="photo" src="{photo.body}" alt="d" />
                    <button on:click={()=>{ onFileRemoved(index); }}><i class="fas fa-trash"></i> Delete</button>
                </div>
                {/each}
            </div>
            <div style="margin: 10px;">
                <button on:click={()=>{fileinput.click();}} style="background-color: #1769aa; color: white;" disabled={is_busy}>Add Photo</button>
                <input style="display:none" type="file" accept=".jpg, .jpeg, .png" on:change={(e)=>onFileSelected(e)} bind:this={fileinput} multiple>
            </div>

        </div>
    </div>


    <div class="section updatebuttonholder">
        <div class="updatebutton">
            <button on:click={() => { createQuote(true); }} disabled={is_busy}>Send Quote</button>
        </div>
        <div class="updatebutton">
            <button on:click={() => { createQuote(false); }} style="background-color: #1769aa;" disabled={is_busy}>Save Quote</button>
        </div>
        <div class="backbutton">
            <button on:click={()=>{ pop(); }}><i class="fas fa-arrow-circle-left"></i> Back</button>
        </div>
    </div>
</div>

<style>
    .ff {
        padding: 10px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    .formrow {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .sectioninfo {
        width: 100%;
    }

    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "ci ci ci ci ci ci ci ci ci ci ci ci"
                             "si si si si si si si si si si si si"
                             "pi pi pi pi pi pi pi pi pi pi pi pi"
                             "cr cr cr cr cr cr cr cr cr cr cr cr"
                             "py py py py py py py py py py py py"
                             "ub ub ub ub ub ub ub ub ub ub ub ub";
        gap: 20px;
    }

    .contactinfo {
        grid-area: ci;
    }
    .pricinginfo {
        grid-area: pi;
    }
    .serviceinfo {
        grid-area: si;
    }
    .photoinfo {
        grid-area: cr;
    }
    .updatebuttonholder {
        grid-area: ub;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .updatebuttonholder button {
        width: 200px;
        margin-right: 10px;
    }
    .updatebutton button {
        background-color: #357a38;
        color: white;
    }
    .backbutton button {
        background-color: #ff9100;
        color: white;
    }
    .photo-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .photo-item {
        display: flex;
        flex-direction: column;
        margin: 10px;
    }
	.photo{
		height: 100px;
		width: 100px;
	}
    .mockgroupitem {
        width: 100%;
        border: solid 1px #ccc;
        border-radius:6px;
        padding-top: 15px;
        background-color: white;
        margin-bottom: 15px;
    }
    .btn-icon {
        margin: 14px 10px 28px 10px;
        border-radius: 4px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 10px;
            width: 100%;
        }
        .formrow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "ci"
                                 "si"
                                 "pi"
                                 "cr"
                                 "py"
                                 "ub";
            gap: 20px;

        }
        .updatebuttonholder {
            grid-area: ub;
            width: 100%;
            display: flex;
            flex-direction: column;
            
        }
        .updatebuttonholder button {
            width: 100%;
            margin-right: 10px;
        }
        .updatebutton button {
            background-color: #357a38;
            color: white;
        }
        .backbutton button {
            background-color: #ff9100;
            color: white;
        }
    }
</style>